module.exports = __webpack_public_path__ + "assets/img/zhys.3f17e1bd.jpg";